import { eventService } from '@/core/services/api/event';

export default {
    namespaced: true,
    state: {
        activeEvents: [],
        monthEvents: {},
        lastEvent: null,
        eventTypeCounts: {
            good: 0,
            neutral: 0,
            bad: 0
        },
        effectNumbers: {},
        hasNoRest: false
    },

    mutations: {
        SET_ACTIVE_EVENTS(state, events) {
            state.activeEvents = events;
        },
        SET_MONTH_EVENTS(state, events) {
            state.monthEvents = events;
        },
        SET_LAST_EVENT(state, event) {
            state.lastEvent = event;
        },
        SET_EVENT_TYPE_COUNTS(state, counts) {
            state.eventTypeCounts = counts;
        },
        SET_EFFECT_NUMBERS(state, { effectType, data }) {
            state.effectNumbers[effectType] = data;
        },
        SET_HAS_NO_REST(state, value) {
            state.hasNoRest = value;
        }
    },

    actions: {
        async fetchActiveEvents({ commit }) {
            const response = await eventService.getActiveEventsWithRemainingDays();
            commit('SET_ACTIVE_EVENTS', response.data);
            return response.data;
        },

        async fetchMonthEvents({ commit }, { month, year }) {
            const response = await eventService.getMonthEvents(month, year);
            // O estado guarda o agrupado `{ [dia]: [...] }` em si; o retorno
            // mantém o envelope `{ data: agrupado }` que o CalendarEvents lê.
            commit('SET_MONTH_EVENTS', response.data.data);
            return response.data;
        },

        async fetchLastEvent({ commit }) {
            const response = await eventService.getLastActiveEvent();
            // O estado guarda o evento em si (ou null); o retorno mantém o
            // envelope `{ event }` que o EventModal lê (`response.event`).
            commit('SET_LAST_EVENT', response.data.event);
            return response.data;
        },

        async fetchEventsByEffect(_, { effectType, effectText }) {
            const response = await eventService.findByEffect(effectType, effectText);
            return response.data;
        },

        async fetchEffectNumbers({ commit }, effectType) {
            const response = await eventService.getSumEffectNumbers(effectType);
            commit('SET_EFFECT_NUMBERS', { effectType, data: response.data });
            return response.data;
        },

        async fetchEventTypeCounts({ commit }) {
            const response = await eventService.getEventTypeCount();
            commit('SET_EVENT_TYPE_COUNTS', response.data);
            return response.data;
        },

        async checkNoRestEvent({ commit }) {
            const response = await eventService.hasNoRestEvent();
            // O estado guarda o booleano (commitar o objeto deixaria o getter
            // sempre truthy); o retorno mantém `{ hasNoRest }`, que é o que o
            // HouseRest lê (`noRestEvent?.hasNoRest`).
            commit('SET_HAS_NO_REST', response.data.hasNoRest);
            return response.data;
        },

        async initializeEvents({ dispatch }) {
            await Promise.all([
                dispatch('fetchActiveEvents'),
                dispatch('fetchLastEvent'),
                dispatch('fetchEventTypeCounts'),
                dispatch('checkNoRestEvent')
            ]);
        }
    },

    getters: {
        getActiveEvents: state => state.activeEvents,
        getMonthEvents: state => state.monthEvents,
        getLastEvent: state => state.lastEvent,
        getEventTypeCounts: state => state.eventTypeCounts,
        getEffectNumbers: state => effectType => state.effectNumbers[effectType],
        hasNoRestActive: state => state.hasNoRest
    }
};
